import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import de from "./de.json";
import en from "./en.json";
import { getSetting } from "../utils/setttings";

export async function initI18n() {
  try {
    const storedLanguage = await getSetting("language");
    if (storedLanguage) {
      i18next.init({
        resources: {
          en: { translation: en },
          de: { translation: de },
        },
        lng: storedLanguage,
        fallbackLng: "de",
        debug: true,
        interpolation: {
          escapeValue: false,
        },
      });
    } else {
      i18next.use(LanguageDetector).init({
        resources: {
          en: { translation: en },
          de: { translation: de },
        },
        fallbackLng: "de",
        debug: true,
        interpolation: {
          escapeValue: false,
        },
      });
    }
  } catch (error) {
    console.error("Error initializing i18next:", error);
  }
}

export function getCurrentLanguage(): string {
  return i18next.language;
}

export function translate(key: string): string {
  return i18next.t(key);
}

export function updateLanguageContent() {
  // initializing -> is set in html file(s) for transition
  // document.body.classList.add("initializing");
  const elements = document.querySelectorAll("[data-i18n], [data-i18n-title]");
  elements.forEach((element) => {
    const key = element.getAttribute("data-i18n");
    if (key) {
      const translation = element.classList.contains("text-upper")
        ? i18next.t(key).toUpperCase()
        : i18next.t(key);
      if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
        element.placeholder = translation;
      } else {
        element.textContent = translation;
      }
    }

    const keyTitle = element.getAttribute("data-i18n-title");
    if (keyTitle) {
      const translation = i18next.t(keyTitle);
      element.setAttribute("title", translation);
    }
  });
  document.body.classList.remove("initializing");
}
